import Mapie from "./mapie.service";

const mapieModule = angular
  .module("app.services.mapie", [])
  .service("Mapie", Mapie);

export default mapieModule;



// WEBPACK FOOTER //
// ./src/services/mapie/mapie.module.js